"use client"

import { Crown } from "lucide-react"
import { Link } from "react-router"
import { useAuth } from "../../contexts/authContext"
import { createPortal } from "react-dom"

export default function PremiumModal({ isOpen, message, feature, onClose }) {
  const {user} = useAuth()

  return createPortal(
    <div className={`modal z-[1100] ${isOpen ? "modal-open" : ""}`} role="dialog" data-feature={feature || undefined}>
      <div className="modal-box relative bg-base-100 ">
        <button
          onClick={onClose}
          className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          aria-label="Close"
        >
          ✕
        </button>

        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl" />
            <div className="bg-primary rounded-full p-4">
              <Crown className="h-8 w-8 " />
            </div>
          </div>
        </div>

        <div className="text-center mb-8">
          <h3 className="text-2xl font-semibold mb-3">Upgrade to Premium</h3>
          <p className="text-base-content/70 text-balance">{message}</p>
        </div>

        <div className="modal-action justify-center">
          <Link 
          to={`/${user?.user_type}/subscription`} 
          onClick={()=>{
            onClose();
          }} 
          className="btn btn-primary w-full sm:w-auto px-8">
            Upgrade
          </Link>
        </div>
      </div>

      <div className="modal-backdrop" onClick={onClose}></div>
    </div>,
    document.body
  )
}
